export default "__VITE_ASSET__BSL$EmZ0__"